import { useRedirectFunctions } from '@propelauth/react';

import { useRelativityAuth } from '@/hooks/useRelativityAuth';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { Icon } from '@/new/components/icon';
import { PageContainer } from '@/new/components/page-container';
import { PageHeader } from '@/new/components/page-header';
import { PageTitle } from '@/new/components/page-title';
import { Button } from '@/new/components/shadcn/button';

export function UserSettings() {
  const { redirectToAccountPage } = useRedirectFunctions();
  const { isAuthenticated, isLoading, isDisconnecting, disconnectRelativity } = useRelativityAuth();

  return (
    <>
      <Breadcrumb items={[{ href: '/', label: 'Home', active: true }]} />

      <PageContainer>
        <PageHeader>
          <PageTitle text="User Settings" />
        </PageHeader>

        <div className="my-8 max-w-2xl space-y-8">
          <p className="mb-4 text-sm text-gray-600">
            Manage your password, email, and other account security settings.
          </p>
          <Button variant="primary" onClick={() => redirectToAccountPage()}>
            Manage Account
          </Button>

          <hr />

          <div>
            <h3 className="mb-2 text-base font-medium">Relativity Connection</h3>

            {isLoading ? (
              <p className="flex items-center gap-2 text-sm text-gray-600">
                <Icon className="lucide--loader-2 animate-spin" />
                Checking Relativity connection...
              </p>
            ) : isAuthenticated ? (
              <>
                <p className="mb-5 text-sm text-gray-600">
                  You are connected to Relativity. Disconnect here if you want Wexler to stop using your current
                  Relativity session.
                </p>
                <Button onClick={disconnectRelativity} disabled={isDisconnecting}>
                  {isDisconnecting ? (
                    <>
                      <Icon className="lucide--loader-2 mr-2 animate-spin" />
                      Disconnecting...
                    </>
                  ) : (
                    'Log out of Relativity'
                  )}
                </Button>
              </>
            ) : (
              <p className="text-sm text-gray-600">
                You are not currently connected to Relativity. The next time you use a Relativity workflow, you will be
                prompted to authenticate again.
              </p>
            )}
          </div>
        </div>
      </PageContainer>
    </>
  );
}
